import api from "../Api";

export const affiliateLoginApi = (data) =>
  api.post("/affiliate/auth/login", data);

export const affiliateProfileApi = () =>
  api.get("/affiliate/profile");

export const getAffiliateDashboardCardsApi = () => {
  return api.get("/affiliate-service/overview");
};

export const getReferralslist = (status = '', earning_type = '', start_date = '', end_date = '', type = 'sum') => {
  let s = status, e = earning_type, sd = start_date, ed = end_date, t = type;
  if (typeof status === 'object' && status !== null) {
    s = status.status || '';
    e = status.earning_type || '';
    sd = status.start_date || '';
    ed = status.end_date || '';
    t = status.type !== undefined ? status.type : 'sum';
  }
  const query = new URLSearchParams();
  if (s) query.append('status', s);
  if (e) query.append('earning_type', e);
  if (sd) query.append('start_date', sd);
  if (ed) query.append('end_date', ed);
  if (t) query.append('type', t);
  return api.get(`/affiliate-service/referrals/list?${query.toString()}`);
};

export const getanalyticstrends = () => {
  return api.get("/affiliate-service/analytics/trends");
};

export const getanalyticsCards = () => {
  return api.get("/affiliate-service/analytics/card");
};

export const getAffiliateBadges = () => {
  return api.get("/affiliate-service/users/badges");
};

export const getAnalyticsGraph = (filter) => {
  return api.get(`/affiliate-service/analytics/graph?period=${filter}`);
};

export const getAnalyticsperformance = () => {
  return api.get(`/affiliate-service/analytics/performance`);
};

export const getProfile = () => {
  return api.get(`/affiliate-service/analytics/profile`);
};

export const getRequestLink = () => {
  return api.put(`/affiliate-service/request-affiliate`);
};

export const getUserupdated = (payload) => {
  return api.put(`/user-service/profile`, payload);
};

export const getwithdrawRequest = (payload) => {
  return api.put(`/affiliate-service/withdraw-request/list`, payload);
};

// /affiliate-service/withdraw-request/list
// /user-service/profile

// /affiliate-service/request-affiliate

// /affiliate-service/analytics/profile


// Chat Messages

// /chat-service/conversations/1
export const getChatMessages = (conversationId) => {
  return api.get(`/chat-service/conversations/${conversationId}/messages?page=1&page_size=200`);
};
// /chat-service/messages
export const sendChatMessage = (formData) => {
  return api.post(`/chat-service/messages`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

// /chat-service/conversations
export const createConversationApi = () => {
  return api.post(`/chat-service/conversations`);
};

// /user-service/wallet/transaction-history
export const getUserWalletTransactionHistory = () => {
  return api.get(`/user-service/wallet/transaction-history`);
};

export const getAffiliateEstimateList = (search = '', fromDate = '', toDate = '', page = 1, limit = 10) => {
  const q = encodeURIComponent(search ?? '');
  return api.get(
    `/affiliate-service/affiliate/estimates/list?page=${page}&limit=${limit}&search=${q}&from_date=${fromDate}&to_date=${toDate}`
  );
};

export const createAffiliateEstimate = (data) => {
  return api.post('/affiliate-service/affiliate/estimate', data);
};

export const getAffiliateMeetingListApi = (page = 1, pageSize = 20, search = '', status = 'All', dateFilter = 'All Time') => {
  const query = new URLSearchParams({
    page,
    page_size: pageSize,
    sort_by: 'scheduled_at',
    sort_order: 'desc'
  });
  if (search) query.append('search', search);
  if (status && status !== 'All') query.append('status', status);

  return api.get(`/meet-service/api/v1/meetings?${query.toString()}`);
};

// Client Outreach APIs
export const getClientOutreachHistoryApi = (params = {}) => {
  const query = new URLSearchParams();
  const search = params.search;
  const email_type = params.email_type || params.emailType;
  const status = params.status;
  const date_from = params.date_from || params.dateFrom;
  const date_to = params.date_to || params.dateTo;
  const limit = params.limit !== undefined ? params.limit : 10;
  const offset = params.offset !== undefined ? params.offset : 0;

  if (search) query.append('search', search);
  if (email_type) query.append('email_type', email_type);
  if (status) query.append('status', status);
  if (date_from) query.append('date_from', date_from);
  if (date_to) query.append('date_to', date_to);
  if (limit !== undefined) query.append('limit', limit);
  if (offset !== undefined) query.append('offset', offset);

  const qs = query.toString();
  return api.get(`/affiliate-service/client-outreach${qs ? `?${qs}` : ''}`);
};

export const getClientOutreachClientsApi = (params = {}) => {
  const query = new URLSearchParams();
  const search = params.search;
  const client_filter = params.client_filter || params.clientFilter;
  const limit = params.limit !== undefined ? params.limit : 20;
  const offset = params.offset !== undefined ? params.offset : 0;

  if (search) query.append('search', search);
  if (client_filter) {
    query.append('client_filter', client_filter);
  }
  if (limit !== undefined) query.append('limit', limit);
  if (offset !== undefined) query.append('offset', offset);

  const qs = query.toString();
  return api.get(`/affiliate-service/client-outreach/clients${qs ? `?${qs}` : ''}`);
};

export const getClientOutreachTemplatesApi = () => {
  return api.get(`/affiliate-service/client-outreach/templates`);
};

export const sendClientOutreachApi = (payload) => {
  return api.post(`/affiliate-service/client-outreach/send`, payload);
};


export const getClientOutreachSignatureApi = async () => {
  try {
    return await api.get('/affiliate-service/client-outreach/signature');
  } catch (err) {
    if (err?.response?.status === 404) {
      return await api.get('/client-outreach/signature');
    }
    throw err;
  }
};

export const updateClientOutreachSignatureApi = async (data) => {
  const payload = typeof data === 'string' ? { signature: data } : data;
  try {
    return await api.put('/affiliate-service/client-outreach/signature', payload);
  } catch (err) {
    if (err?.response?.status === 404) {
      return await api.put('/client-outreach/signature', payload);
    }
    throw err;
  }
};
